import { render, staticRenderFns } from "./detailsPurchaseReturnRecord.vue?vue&type=template&id=16a1eaef"
import script from "./detailsPurchaseReturnRecord.vue?vue&type=script&lang=js"
export * from "./detailsPurchaseReturnRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports